export const TOPIC_EXPLORER_PAGE_DESCRIPTION =
  'Explore the topic of your choice! Topic Explorer provides detailed information and insights on the topics needed for your class discussion.';

export const TOPIC_EXPLORER_PAGE_EXPLORE =
  'What topic would you like to explore?';
